module.exports = "<app-header></app-header>\n<div class=\"container  mb-5\">\n  <router-outlet></router-outlet>\n</div>\n<app-footer></app-footer>\n"